import { render, staticRenderFns } from "./SyringeIcon.vue?vue&type=template&id=1b486462&scoped=true&"
import script from "./SyringeIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SyringeIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b486462",
  null
  
)

export default component.exports